import { Chapter, Reveal } from "@/components/Reveal";
import { GhostCTA } from "@/components/CTA";

const AboutTeaser = () => (
  <section id="chi-sono" data-testid="about-section" className="bg-fog py-28 text-ink lg:py-40">
    <div className="mx-auto max-w-[1440px] px-6 lg:px-12">
      <div className="grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Reveal>
            <div className="relative">
              <div className="absolute -left-3 -top-3 h-full w-full border border-accent-dark/30" aria-hidden="true" />
              <img
                src="/assets/solo-hero.jpg"
                alt="Mattia Cosimo Saracino — Consulente Aziendale"
                loading="lazy"
                data-testid="about-photo"
                className="relative aspect-[3/4] w-full object-cover object-top"
              />
            </div>
          </Reveal>
        </div>
        <div className="flex flex-col justify-center lg:col-span-7">
          <Chapter index="10" label="Chi sono" />
          <Reveal>
            <h2 className="font-display text-4xl font-extrabold leading-[1.05] tracking-tighter sm:text-5xl">
              Prima delle aziende, vengono le persone.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-10 font-display text-2xl font-bold tracking-tight">Mattia Cosimo Saracino</p>
            <p className="mt-2 font-mono text-[11px] uppercase tracking-[0.3em] text-accent-dark">
              Consulente Aziendale
            </p>
            <p className="mt-8 max-w-xl text-base leading-relaxed text-ink/60">
              Dal marketing e dalla direzione esecutiva nel mondo dello spettacolo alla consulenza
              aziendale: una convinzione semplice — prima di cambiare un'azienda bisogna capire le
              persone che la fanno funzionare.
            </p>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-ink/60">
              Non cerco soluzioni standard. Cerco il punto che sta limitando la crescita.
            </p>
          </Reveal>
          <Reveal delay={0.15} className="mt-10">
            <GhostCTA to="/chi-sono" testid="about-cta">
              Leggi la mia storia
            </GhostCTA>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default AboutTeaser;
